import React, { useState } from 'react';

const ValueOfPercentage = () => {
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');

  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('يرجى ادخال القيمتين بشكل صحيح');
      setResult('');
      setExplanation('');
      return;
    }
    const isPercentageOf = (parseFloat(value1) / parseFloat(value2)) * 100;
    setResult(isPercentageOf.toFixed(2));
    setExplanation(
      `${value1} هو كم % من ${value2} = (${value1} / ${value2}) * 100 = ${(parseFloat(value1) / parseFloat(value2)) * 100} = ${isPercentageOf.toFixed(2)}`
    );
    setError('');
  };

  return (
    <div dir="rtl">
      <style>{`
        .vop-row {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
        }
        .vop-inputs {
          display: flex;
          align-items: center;
          gap: 6px;
          flex: 1;
        }
        .vop-btn {
          font-size: 20px;
          white-space: nowrap;
        }
        @media (max-width: 767px) {
          .vop-inputs {
            width: 100%;
            flex: unset;
          }
          .vop-btn {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>

      <div className="vop-row">
        <div className="vop-inputs">
          <input
            type="number"
            placeholder="القيمة"
            value={value1}
            onChange={(e) => setValue1(e.target.value)}
            className="form-control"
            style={{ flex: 1 }}
          />
          <span>هو كم % من</span>
          <input
            type="number"
            placeholder="القيمة"
            value={value2}
            onChange={(e) => setValue2(e.target.value)}
            className="form-control"
            style={{ flex: 1 }}
          />
        </div>
        <button
          className="btn btn-success"
          onClick={handleCalculate}
        >
          إحسب
        </button>
      </div>

      <br />
      <div>
        {error !== '' ? (
          <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className="p-3 mb-2 bg-success text-white">
                  النتيجة: {value1} هو {result}% من {value2}
                </p>
                {explanation !== '' && (
                  <p className="p-3 mb-2 bg-info text-black">
                    خطوات الحل: <br />{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ValueOfPercentage;